/**
 * The DOM id a codex card publishes, so a mention in the prose can scroll to it.
 *
 * Its own module rather than an export from `cards.tsx`, mirroring
 * `features/story/chapterAnchor.ts`: a file that exports both a component and a helper cannot
 * be hot-replaced, and these cards are exactly what one edits with the panel open.
 *
 * **Minted on the `Section` card only.** `HereNow` draws the people at the current location a
 * second time, with the same `Npc` component, so two nodes can exist per key — and an id that
 * appears twice makes `getElementById` a coin flip.
 */
import type { MentionKind } from '@/api/generated';

export function codexElementId(kind: MentionKind, key: string): string {
  return `codex-${kind}-${key}`;
}
